module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-500.woff?6e76a4cee4838c4ffac07e8b2be5f187";